import { Box } from "@chakra-ui/layout";
import {
  GrupoDescontoForm,
  FormaAplicacaoValorEnum,
} from "core/features/grupo-desconto/typings";
import { useForm } from "react-hook-form";
import FooterModal from "ui/components/Button/FooterModal";
import FormGrupoDesconto from "./FormGrupoDesconto";
import { TipoDestinoEnum } from "core/features/documentos/enums";
import useGrupoDesconto from "core/features/grupo-desconto/hooks/useGrupoDesconto";
import { useLoading } from "ui/components/GlobalLoading/index";
import { useEffect } from "react";

interface FormGrupoDescontoGeralProps {
  id?: string;
  onClose: () => any;
  onSave: (data: GrupoDescontoForm) => any;
  isLoadingSave?: boolean;
}

function FormGrupoDescontoGeral({
  id,
  onSave,
  onClose,
  isLoadingSave,
}: FormGrupoDescontoGeralProps) {
  const { data, isLoading, isFetching } = useGrupoDesconto(id);

  const { control, formState, watch, handleSubmit, setValue, reset } =
    useForm<GrupoDescontoForm>({
      reValidateMode: "onChange",
      mode: "all",
      defaultValues: {
        categoriasIds: [],
        personalizado: "1",
        tipoDestinoId: TipoDestinoEnum.UmGrupoUnidades,
        todasCategorias: "1",
        formaAplicacaoValorId: FormaAplicacaoValorEnum.ValorFixo,
        antesVencimento: "0",
      },
    });

  const form = watch();

  useEffect(() => {
    if (data) {
      reset({
        ...data,
        personalizado: data.personalizado ? "1" : "0",
        todasCategorias: data.todasCategorias ? "1" : "0",
        antesVencimento: data.antesVencimento ? "1" : "0",
      });
    }
  }, [data, reset]);

  const onSubmit = (data: GrupoDescontoForm) => {
    onSave({
      ...data,
      antesVencimento:
        data.personalizado === "1" ? false : data.antesVencimento === "1",
      personalizado: data.personalizado === "1",
      todasCategorias: data.todasCategorias === "1",
    });
  };

  useLoading(isLoading || isFetching);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <>
        <Box pt="16px">
          <FormGrupoDesconto
            control={control}
            form={form}
            setValue={setValue}
          />
        </Box>

        <FooterModal
          isDisabled={!formState.isValid}
          isLoadingSave={isLoadingSave}
          onSubmit={handleSubmit(onSubmit)}
          onClose={onClose}
          showRegisterAnother={false}
          primaryButtonText={(id ? "Editar" : "Criar") + " grupo de desconto"}
        />
      </>
    </form>
  );
}

export default FormGrupoDescontoGeral;
